export const AvailabilityState = {
  Available: 'Available',
  NotAvailable: 'NotAvailable',
  NotSet: 'NotSet',
} as const;

type AvailabilityStateKey = keyof typeof AvailabilityState;
export type AvailabilityStateType =
  (typeof AvailabilityState)[AvailabilityStateKey];

export const AvailabilityStates: AvailabilityStateType[] =
  Object.values(AvailabilityState);
